<template>
<div v-if="!showCanvas" class="home">
  <div class="button" @click="addCanvas">新建画板</div>
  <div class="button" @click="joinCanvas">加入画板</div>
</div>
<my-canvas ref="canvas" v-else :creator="creator"></my-canvas>
<!--  <div class="button" @click="showError" style="position: fixed;bottom: 0;left: 0">error</div>-->
</template>

<script>
import myCanvas from "./canvas";
import random from '../utils/random.js'
import bus from "@/utils/bus";
import url from '../config.js'
export default {
  name: "home",
  components: {
    myCanvas
  },
  data() {
    return{
      socket: null,
      path: url.baseUrl,
      showCanvas: false,
      canvasId: '',
      creator: false,
      socketTimer: null,
      errorCount: 0,
      code: ''
    }
  },
  computed: {
    uid() {
      return this.$store.state.uid
    }
  },
  mounted() {
    this.init()
    console.log(random())
    bus.$on('writing', this.emitWriting)
    bus.$on('emitClear', this.emitClear)
    bus.$on('sendPoint', this.sendPoint)
    // 自动加入画板
    if (this.$route.query && this.$route.query.code) {
      this.code = this.$route.query.code
    }
  },
  beforeUnmount() {
    this.socket.close()
  },
  unmounted() {
    bus.$off('writing', this.emitWriting)
    bus.$off('emitClear', this.emitClear)
    bus.$off('sendPoint', this.sendPoint)
    clearInterval(this.socketTimer)
  },
  methods: {
    init: function () {
      if(typeof(WebSocket) === "undefined"){
        alert("您的浏览器不支持socket")
      }else{
        // 实例化socket
        this.socket = new WebSocket(this.path)
        // 监听socket连接
        this.socket.onopen = this.open
        // 监听socket错误信息
        this.socket.onerror = this.error
        // 监听socket消息
        this.socket.onmessage = this.getMessage
        this.socket.onclose  = this.close
      }
    },
    open: function () {
      console.log("socket连接成功")
      this.errorCount = 0
      if (this.code) {
        const code = this.code.replace(/\s/g, "")
        this.canvasId = code
        this.creator = false
        this.firstEmit()
        this.showCanvas = true
        this.$store.commit('setCanvasId', this.canvasId)
        this.emitPoint()
      } else {
        // 查看是否有canvasid
        const canvasId = sessionStorage.getItem('canvasId')
        if (canvasId) {
          const openOld = confirm(`是否打开id为${canvasId}的画板？`)
          if (openOld) {
            this.addCanvas(true)
            // 从本地读取缓存
            if (!this.restorePoints()) {
              this.send({msgType: 'clear'})
            }
          } else {
            sessionStorage.removeItem('canvasId')
          }
        }
      }
      // 心跳
      if (this.socketTimer) {
        clearInterval(this.socketTimer)
      }
      this.socketTimer = setInterval(() => {
        this.send({msgType: 'test'})
      }, 10000)
    },
    error: function () {
      this.errort = '连接错误'
      console.log("连接错误")
      if (this.errorCount > 10) {
        return
      }
      this.errorCount += 1
      this.init()
      setTimeout(() => {
        this.firstEmit()
      }, 500)
    },
    getMessage: function (msg) {
      const params = JSON.parse(msg.data)
      console.log('getMsg', params)
      if (params.msgType === 'writing') {
        bus.$emit('getWriting', params)
      } else if(params.msgType === 'clear') {
        bus.$emit('getClear')
      } else if(params.msgType === 'emitPoint') {
        bus.$emit('emitPoint', params.targetId)
      } else if (params.msgType === 'sendPoint') {
        bus.$emit('getPoint', params)
      } else if (params.msgType === 'noData') {
        if (this.showCanvas && !this.creator) {
          alert('分享码不正确或者画板已解散')
          this.canvasId = ''
          this.showCanvas = false
          this.$store.commit('setCanvasId', this.canvasId)
        } else if (this.creator) {
          this.restorePoints()
        } else {
          console.log(this.showCanvas, this.creator)
        }

      }
    },
    send: function (params) {
      // console.log(params)
      params = { ...params, uid: this.uid, canvasId: this.canvasId, creator: this.creator }
      this.socket.send(JSON.stringify(params))
    },
    close: function () {
      this.errort = 'socket已经关闭'
      console.log("socket已经关闭")
      if (this.errorCount > 10) {
        return
      }
      this.errorCount += 1
      this.init()
      setTimeout(() => {
        this.firstEmit()
      }, 500)
    },
    emitWriting(e) {
      // console.log(e)
      this.send({...e, msgType: 'writing'})
    },
    addCanvas(old) {
      this.canvasId = old === true ? sessionStorage.getItem('canvasId') : random()
      this.creator = true
      this.firstEmit()
      this.showCanvas = true
      sessionStorage.setItem('canvasId', this.canvasId)
      this.$store.commit('setCanvasId', this.canvasId)
    },
    joinCanvas() {
      var code = prompt('请输入分享码')
      console.log(code)
      if (code) {
        code = code.replace(/\s/g, "")
        this.canvasId = code
        this.creator = false
        this.firstEmit()
        this.showCanvas = true
        this.$store.commit('setCanvasId', this.canvasId)
        this.emitPoint()
      }
    },
    firstEmit() {
      this.send({canvasId: this.canvasId, creator: this.creator, uid: this.uid, msgType: 'first'})
    },
    emitClear() {
      this.send({msgType: 'clear'})
    },
    showError() {
      alert(this.errort)
    },
    emitPoint() {
      this.send({msgType: 'emitPoint'})
    },
    sendPoint(params) {
      this.send({msgType: 'sendPoint', ...params})
    },
    restorePoints() {
      const pointsObj = JSON.parse(localStorage.getItem('points'))
      if (pointsObj && pointsObj.id === this.canvasId) {
        // 还原画板内容
        this.showCanvas = true
        this.$nextTick(() => {
          this.$refs.canvas.setPoints(pointsObj.value)
          console.log(this.$refs.canvas, pointsObj.value)
        })
        return true
      }
      return false
    }
  }
}
</script>

<style scoped>
.home{
  height: 200px;
  display: flex;
  justify-content: center;
}
.button{
  width: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 8px;
  border: 1px solid cornflowerblue;
  font-size: 18px;
  color: #333;
}
</style>
